/* eslint-disable */
import { Box } from "@mui/system";
import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { Button } from "@mui/material";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
const BackButtonBox = styled(Box)(({ theme }) => ({
  position: "fixed",
  bottom: "80px",
  right: "25px",
  opacity: 0,
  visibility: "hidden",
  transition: "opacity 0.4s ease, visibility 0.4s ease",
  "&.visible": {
    opacity: 1,
    visibility: "visible",
  },

  "& button": {
    textTransform: "none",
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    borderRadius: "50%",
    minWidth: "56px",
    boxShadow: "none",
    marginBottom: "15px",
    width: "56px",
    height: "56px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    "@media screen and (max-width:600px)": {
      width: "100%",
    },
    "&:focus": {
      outline: "0",
    },
    "& svg": {
      fontSize: "30px",
    },
  },
  "& a": {
    color: "#ffffff",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Plus Jakarta Sans', sans-serif !important",
    "& svg": { marginRight: "6px", fontSize: "22px", transition: "0.9s ease-out" },
  },
  "&:hover": {
    boxShadow: "none",
    backgroundColor: theme.palette.common.hoverBtn,
    color: theme.palette.common.white,
    "& a": { color: "#ff642d" },
    "& svg": { transform: "rotateZ(720deg)" },
  },
  "&:focus": { outline: "none" },
}));

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when user scrolls down
  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <BackButtonBox className={isVisible ? "visible" : ""}>
      <Button onClick={scrollToTop}>
        <ArrowCircleUpIcon />
      </Button>
    </BackButtonBox>
  );
};

export default BackToTop;
